import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorTarget = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="m18.425 8.413 3.327-3.333h-2.666V2.413l-3.334 3.334v1.726l-3.14 3.14a1.986 1.986 0 0 0-.86-.2c-1.107 0-2 .893-2 2s.893 2 2 2 2-.893 2-2c0-.306-.073-.593-.2-.86l3.14-3.14h1.733Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M3.405 12.623a8.25 8.25 0 0 1 10.68-8.096.75.75 0 1 0 .442-1.433 9.74 9.74 0 0 0-3.122-.428c-5.383.137-9.636 4.612-9.5 9.995.137 5.383 4.612 9.636 9.995 9.499 5.383-.137 9.636-4.611 9.499-9.995a9.76 9.76 0 0 0-.388-2.495.75.75 0 0 0-1.44.421c.196.671.31 1.379.328 2.113a8.25 8.25 0 1 1-16.494.419Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M7.404 12.521a4.25 4.25 0 0 1 5.164-4.26.75.75 0 0 0 .322-1.464 5.75 5.75 0 1 0 4.392 4.439.75.75 0 0 0-1.469.305 4.25 4.25 0 1 1-8.41.98Z"
    />
  </svg>
);
export default SvgTwoColorTarget;
